const link = {
  defaultProps: {
    underline: "none" as const,
    color: "inherit" as const,
  },
};

export default link;
